import { cx } from '@linaria/core';
import { useUserIdentityState } from '@provider/user-identity';
import { IconButton } from '@ui/kit';
import { formatTimestamp } from '@utils/common';
import { CSSRefTransition } from '@utils/react';
import { useUpdateDialogueMutation } from './api.update-dialogue.mutation.js';
import { date, entry, meta, messageWrapper, message, retryButton, retryButtonTransitionDurationMs } from './atom.dialogue-entry.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function DialogueEntry(props) {
  const user = useUserIdentityState(state => state.user);
  const sender = props.entry.author?.id === user?.id ? "self" : "other";
  return props.entry.type === "event" ? /*#__PURE__*/jsx(EventEntry, {
    ...props,
    entry: props.entry,
    sender: sender
  }) : /*#__PURE__*/jsx(MessageEntry, {
    ...props,
    entry: props.entry,
    sender: sender
  });
}
function EventEntry(props) {
  return /*#__PURE__*/jsxs("div", {
    className: cx(entry, meta),
    "data-sender": props.sender,
    children: [props.entry.eventType === "shared" ? "Delt" : "Opdateret", " ", props.entry.author ? /*#__PURE__*/jsxs(Fragment, {
      children: ["af ", /*#__PURE__*/jsx("b", {
        children: props.entry.author.name
      })]
    }) : "", " ", /*#__PURE__*/jsxs("span", {
      className: date,
      children: ["d.", " ", formatTimestamp(props.entry.timestamp, {
        includeTime: true,
        dateSeparator: "."
      })]
    })]
  });
}
function MessageEntry(props) {
  const updateDialogue = useUpdateDialogueMutation();
  return /*#__PURE__*/jsxs("div", {
    className: cx(entry, props.entry.state === "failed" && "failed"),
    "data-sender": props.sender,
    children: [/*#__PURE__*/jsxs("div", {
      className: meta,
      children: [props.entry.author ? /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("b", {
          children: props.entry.author.name
        }), " ", props.entry.author.role === "student" ? "ELEV" : "LÆRER"]
      }) : "", " ", /*#__PURE__*/jsxs("span", {
        className: date,
        children: ["d.", " ", formatTimestamp(props.entry.timestamp, {
          includeTime: true,
          dateSeparator: "."
        })]
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: messageWrapper,
      children: [/*#__PURE__*/jsx("div", {
        className: message,
        children: props.entry.plainTextContent
      }), /*#__PURE__*/jsx(CSSRefTransition, {
        in: props.entry.state === "failed",
        timeout: retryButtonTransitionDurationMs,
        classNames: retryButton,
        mountOnEnter: true,
        unmountOnExit: true,
        children: ref => /*#__PURE__*/jsx(IconButton, {
          ref: ref,
          className: retryButton,
          icon: /*#__PURE__*/jsx(Fragment, {
            children: "!"
          }),
          label: /*#__PURE__*/jsxs(Fragment, {
            children: ["Beskeden kunne ikke sendes.", /*#__PURE__*/jsx("br", {}), "Klik her for at sende beskeden igen"]
          }),
          async: {
            showThrobberWhilePending: true,
            showStatesAfterResult: true
          },
          onClick: () => updateDialogue.mutateAsync({
            dialogueId: props.dialogueId,
            ...props.entry
          })
        })
      })]
    })]
  });
}

export { DialogueEntry };
//# sourceMappingURL=atom.dialogue-entry.js.map
